import reportTypes from 'Constants/report-types';

export default {
    [reportTypes.shareholderListTemplate]: 14, // In case of 1 default unmanageable column.
    [reportTypes.shareholderTableTemplate]: 15
};
